import React, { useState } from "react";
import { Link } from "react-router";
import { formatModelName } from "./helpers/utils";

const CoverArt = ({ coverArtUrls, albumCoverUrl, coverArtModel, openAppModal, closeAppModal, size = "small", css, selectedOption }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleOpenModal = () => {
    if (!openAppModal) return;
    const modalContent = (
      <>
        {coverArtUrls?.large && (
          <div className="large-album-art">
            <img
              src={coverArtUrls?.large}
              alt="Cover art"
             />
          </div>
        )}

        {albumCoverUrl && (
          <div className="large-album-art mt-3">
            <img
              src={albumCoverUrl}
              alt="Album cover"
            />
          </div>
        )}

        <div className="box mt-2">
          {coverArtModel ? `Art generated by ${formatModelName(coverArtModel)}` : "Art generated by various AI models"}<br />
          <Link to="/cover-art" onClick={closeAppModal} className="button mt-2">Browse All Art</Link>
        </div>
      </>
    );
    openAppModal(modalContent);
  };

  const selectedImage = selectedOption === "albumCover" ? albumCoverUrl : coverArtUrls?.[size];

  return (
    <div
      className={`cover-art cover-art-modal-trigger ${isLoaded ? "" : "loading-shimmer"}`}
      onClick={handleOpenModal}
    >
      <img
        src={selectedImage}
        alt={selectedOption === "coverArt" ? "Cover art" : "Album cover"}
        className={css || ""}
        onLoad={() => setIsLoaded(true)}
        loading="lazy"
      />
    </div>
  );
};

export default CoverArt;
